import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import s from '../Dashboards.styles';

const MainDashboard = ({ children }) => {
  return (
    <s.Wrapper>
      <s.Title>
        <Trans>DASHBOARD</Trans>
      </s.Title>
      <s.DashboardContent>{children}</s.DashboardContent>
    </s.Wrapper>
  );
};

MainDashboard.propTypes = {
  children: PropTypes.any,
};

export default React.memo(MainDashboard);
